// ?allowtoken= handling shared by api.js and dallasapi.js.
//
// The patient-intake pages are public: texted / website links, nobody logged in.
// The short links care.brainymed.com/onboard/{odessa,frisco,code} (Apache) still
// append ?allowtoken=<the shared 'onboarding-link' token>. That token is public,
// so the API refuses it on every staff route (403) and treats it as anonymous on
// the intake routes (2026-10-02). It is therefore never stored here:
//  - on an intake page nothing is stored (the page needs no token at all), and a
//    leftover intake token from an older visit is dropped, so a staff sign-in in
//    the same browser is never overwritten by it;
//  - an allowtoken that is an intake token (sub onboarding-link, or a scope /
//    aud claim) is not stored on any other page either.
// Other ?allowtoken= flows (staff links that open one page with a real login)
// keep working as before.

// Public intake routes (prefix match, as unrestrictedRoutes): /patient covers
// /patient1111 and /patient-enrollment.
export const PUBLIC_INTAKE_ROUTES = ["/onboard-odessa", "/onboard-frisco", "/onboard-code", "/patient"];

export const isPublicIntakePath = (pathname) =>
  PUBLIC_INTAKE_ROUTES.some((route) => String(pathname || "").startsWith(route));

export function isIntakeToken(token) {
  try {
    const part = String(token || "").split(".")[1];
    if (!part) return false;
    const payload = JSON.parse(atob(part.replace(/-/g, "+").replace(/_/g, "/")));
    return payload?.sub === "onboarding-link" || Boolean(payload?.scope) || Boolean(payload?.aud);
  } catch (e) {
    return false;
  }
}

export function captureAllowToken(tag = "API", storage = window.localStorage, loc = window.location) {
  try {
    const allowToken = new URLSearchParams(loc.search).get("allowtoken");
    if (isPublicIntakePath(loc.pathname)) {
      const current = storage.getItem("auth");
      if (current && isIntakeToken(current)) storage.removeItem("auth");
      return false;
    }
    if (allowToken && !isIntakeToken(allowToken)) {
      storage.setItem("auth", allowToken);
      console.log(`[${tag}] Token captured from URL and saved to localStorage`);
      return true;
    }
  } catch (e) {
    // storage blocked (private mode): nothing to capture
  }
  return false;
}
